const PHONETYPE = 'web';
const APPID = 'com.pokekara.web';

const GLOBAL_USER_RELATION_CHANGE = 'global_user_relation_change_event';
const GLOBAL_USER_MEMBERSHIP_CHANGE = 'global_user_membership_change_event';
const BROADCASTNAMES = {
    RewardTaskDidCompleteMVView: 'RewardTaskDidCompleteMVView',
    PokeRoomWebViewIconDataUpdated: 'PokeRoomWebViewIconDataUpdated',
    CacheHitCallBack: 'cache_hit_callback'
};
const config = {
    defaultUserCover: 'https://cdn.pokekara.com/int/webkara/pstatic/user.png',
    defaultMvCover: 'https://cdn.pokekara.com/int/webkara/pstatic/d_home_default.png',
    EVENTGIFTICON:'http://cdn.pokekara.com/int/webkara/pstatic/icon/agift.png',
    RELATIONSHIPFOLLOWED: 2,
    RELATIONSHIPNOFOLLOW: 0,
    RELATIONSHIPFOLLOW: 1,
    langMap: {
        ja_JP: 'ja',
        ja_CN: 'zh-hans'
    },
    JPLANGKEY: 'ja_JP',
    CNLANGKEY: 'ja_CN',
    PROTOCOL: 'https://cdn.pokekara.com/',
    UPLOADAPI: 'https://api-tc.pokekara.com/f/common/upload',
    WEBPROTOCOL: 'https://www.pokekara.com/',
    WEBSHAREPROTOCOL: 'https://u.pokekara.com/',
    TINYPNGUPLOADAPI:"https://test.api.pokekara.com/webkara/mid/upload",
    GAMEEFFECT:'https://cdn.pokekara.com/sp1/pokekara/png/large/fb/c2/fbb558b6750033ea305807709aa3d8c2_132-132-0.png',
    LIVEEFFECT:'https://cdn.pokekara.com/sp1/pokekara/png/large/2a/29/2a6b025b7ebfb1aaaf1107957b245229_132-132-0.png',
    AUTIOEFFECT:'https://cdn.pokekara.com/sp1/pokekara/png/large/cc/2a/ccf127f646eef27886063650c8b30f2a_132-132-0.png'
};
export {
    config,
    GLOBAL_USER_RELATION_CHANGE,
    GLOBAL_USER_MEMBERSHIP_CHANGE,
    PHONETYPE,
    APPID,
    BROADCASTNAMES
};
